/**
 * Grefi — Product carousels (Best Sellers + What's New)
 */
(function () {
  const initCarousel = (section) => {
    const track = section.querySelector('.grefi-bs__track, .grefi-wn__track');
    const prev = section.querySelector('.grefi-bs__arrow--prev, .grefi-wn__arrow--prev');
    const next = section.querySelector('.grefi-bs__arrow--next, .grefi-wn__arrow--next');
    const progressBar = section.querySelector('.grefi-bs__progress-bar, .grefi-wn__progress-bar');

    if (!track) return;

    const getScrollAmount = () => {
      const slide = track.querySelector('.grefi-bs__slide, .grefi-wn__slide');
      if (!slide) return 280;
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      return slide.offsetWidth + gap;
    };

    const updateControls = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft >= maxScroll - 4;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd || maxScroll <= 0;

      if (progressBar && maxScroll > 0) {
        const ratio = track.clientWidth / track.scrollWidth;
        const left = (track.scrollLeft / maxScroll) * (100 - ratio * 100);
        progressBar.style.width = `${ratio * 100}%`;
        progressBar.style.left = `${left}%`;
      }
    };

    prev?.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  };

  document.querySelectorAll('grefi-bestsellers, grefi-whats-new').forEach(initCarousel);
})();
